export default __webpack_public_path__ + "static/1-14c9fa6359f6e6fe398b2fc797573fcd.jpeg";